import { render, staticRenderFns } from "./VRow.vue?vue&type=template&id=7a55ef56&scoped=true&"
import script from "./VRow.vue?vue&type=script&lang=js&"
export * from "./VRow.vue?vue&type=script&lang=js&"
import style0 from "./VRow.vue?vue&type=style&index=0&id=7a55ef56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a55ef56",
  null
  
)

export default component.exports